<div class="bb-block mb-5" *ngFor="let illustration of illustrations">
  <h2>{{ illustration.size }}</h2>
  <bb-illustration-ui
    [name]="illustration.name"
    [size]="illustration.size"
    [assetPath]="illustration.assetPath"
    [priority]="illustration.priority"
  ></bb-illustration-ui>
</div>
